import { render, staticRenderFns } from "./DocumentDropdown.vue?vue&type=template&id=0b5a631e&"
import script from "./DocumentDropdown.vue?vue&type=script&lang=ts&"
export * from "./DocumentDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports